module.exports = __webpack_public_path__ + "static/media/boros.8737aeb5.jpg";